var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('v-flex',{staticClass:"spinner-container",attrs:{"pa-5":""}},[_c('div',{staticClass:"spinner"})]):_c('v-flex',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }